import { simpleSet } from '@r/reducers/utils';

const setCalculationModePullsValue = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.materials.pulls.value;

export const value = setCalculationModePullsValue(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_PULLS_VALUE',
  { value: '', label: '' }
);
